import type { FC } from "react";
import { Badge, BadgeSize, BadgeVariant, Show } from "shared/components";
import type { ReportMetric } from "api/owner-screening-report";
import { METRIC_FORMATS, METRIC_LABELS } from "../constants";
import { formatField } from "../format";

/**
 * One group total. The scope line repeats under every card on purpose: an owner
 * reading "Gross income $12,400" needs to know whose income that is before the
 * number means anything.
 */
export const MetricCard: FC<{ metric: ReportMetric }> = ({ metric }) => {
  const label = metric.title || METRIC_LABELS[metric.metric] || metric.metric;
  const value = formatField(
    metric.value,
    METRIC_FORMATS[metric.metric] ?? "number"
  );

  return (
    <div className="flex flex-col gap-1 rounded-lg border border-alpha-100 bg-background-1000 p-4 shadow-xs break-inside-avoid">
      <div className="flex items-start justify-between gap-2">
        <span className="text-sm text-content-500">{label}</span>
        <Show if={metric.verified}>
          <Badge
            variant={BadgeVariant.SUCCESS}
            size={BadgeSize.SM}
            className="shrink-0"
          >
            Verified
          </Badge>
        </Show>
      </div>
      <span className="text-2xl font-bold text-content-1000">
        {value ?? "—"}
      </span>
      <Show if={Boolean(metric.scope_label)}>
        <span className="text-xs text-content-400">{metric.scope_label}</span>
      </Show>
    </div>
  );
};
